import type { EtiquetaDaOpcao as DadosDaEtiqueta, TomDaEtiqueta } from './Campo';

/**
 * O fundo e o texto de cada tom, só de token (a escolha de cada tom está em
 * `TomDaEtiqueta`, no `Campo.tsx`). Os pares são os que o sistema já usa com
 * texto em cima: a tinta e o texto do azul de informação (o mesmo par do
 * selo `Disponível`, 4,5:1 ou mais nos dois temas), o texto sobre o card
 * invertido (o avatar da pessoa logada, p.25) e o rebaixado com o texto da
 * lista (a etiqueta neutra da p.25).
 */
const TOM: Record<TomDaEtiqueta, string> = {
  informacao: 'bg-informacao-fundo text-informacao-texto',
  escuro: 'bg-tinta text-card',
  neutro: 'bg-rebaixada text-tinta-lista',
};

/** O que o leitor de tela e a dica dizem: "Placa ABC1D23". */
function textoDaEtiqueta(etiqueta: DadosDaEtiqueta): string {
  return etiqueta.titulo ? `${etiqueta.titulo} ${etiqueta.texto}` : etiqueta.texto;
}

/**
 * UMA ETIQUETA DA OPÇÃO (p.25: a etiqueta é atributo, raio 8): o código
 * interno, a placa, o produto do tanque. Texto do selo (12/600) em IBM Plex
 * Mono, porque o que vai nela é código; 20 px de altura na lista e no campo
 * da mesa, 24 no celular, para caber na linha sem empurrar a altura dela.
 * Nunca quebra nem corta o texto: o código cortado é o erro que ela existe
 * para evitar.
 */
export function EtiquetaDaOpcao({
  etiqueta,
  tamanho = 'p',
}: {
  readonly etiqueta: DadosDaEtiqueta;
  readonly tamanho?: 'p' | 'm';
}) {
  return (
    <span
      title={textoDaEtiqueta(etiqueta)}
      className={`txt-selo mono inline-flex shrink-0 items-center rounded-etiqueta px-2 whitespace-nowrap ${
        tamanho === 'm' ? 'h-6' : 'h-5'
      } ${TOM[etiqueta.tom]}`}
    >
      {etiqueta.titulo ? <span className="sr-only">{`${etiqueta.titulo} `}</span> : null}
      {etiqueta.texto}
    </span>
  );
}
